<app-invoice-info [invoiceInfo]="invoiceData"></app-invoice-info>
<app-payment-tab-detail [data]="invoiceData"></app-payment-tab-detail>